// extracted by mini-css-extract-plugin
export var attachment = "_rq-a";
export var emailContainer = "_rq-4";
export var emailContentPaddedContainer = "_rq-b";
export var emailHeader = "_rq-6";
export var emailIframe = "_rq-3";
export var emailInfoIcon = "_rq-9";
export var emailShortenedSummary = "_rq-e";
export var infoDropdown = "_rq-0";
export var infoRowBoundedContent = "_rq-d";
export var internal = "_rq-5";
export var merchant = "_rq-8";
export var messageInputContainer = "_rq-h";
export var normal = "_rq-7";
export var replyCard = "_rq-f";
export var subtleButton = "_rq-1";
export var subtleButtonIconContainer = "_rq-2";
export var toggleViewRepliesButton = "_rq-c";
export var wrappingText = "_rq-g";